import { VueExtension } from '../../utils/extensions/vue';
import Rate from './rate.jsx';
import './rate.scss';

VueExtension.WithInstall(Rate);

export default Rate;
